import {faCreditCard} from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import {faMoneyBill} from "@fortawesome/pro-solid-svg-icons/faMoneyBill";
import {faRepeat} from "@fortawesome/pro-solid-svg-icons/faRepeat";
import {faChartSimple} from "@fortawesome/pro-solid-svg-icons/faChartSimple";
import {ColourSolid} from "@twigsby/frontend-framework";
import {Renew} from "../../Pages/User/Payment/Renew";
import {TopUp} from "../../Pages/User/Payment/TopUp";
import Transactions from "../../Pages/User/Payment/Transactions";
import PaymentDetails from "../../Pages/User/Payment/PaymentDetails";
import {SuggestibleRouteInterface} from "../TopRoutes";

const PaymentRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Payment Details',
        path: '/manage-account/payment/details',
        icon: faCreditCard,
        element: <PaymentDetails />,
        colour: ColourSolid.Warning,
        group: 'Payment'
    },
    {
        title: 'Top-up',
        path: '/manage-account/payment/top-up',
        icon: faChartSimple,
        element: <TopUp />,
        colour: ColourSolid.Warning,
        group: 'Payment'
    },
    {
        title: 'Renew',
        path: '/manage-account/payment/renew',
        icon: faRepeat,
        element: <Renew />,
        colour: ColourSolid.Warning,
        group: 'Payment'
    },
    {
        title: 'Transactions',
        path: '/manage-account/payment/transactions',
        icon: faMoneyBill,
        element: <Transactions />,
        colour: ColourSolid.Warning,
        group: 'Payment'
    },
]

export { PaymentRoutes }
